import React from 'react';
import '../styles/PolitiqueConfidentialite.css';

function PolitiqueConfidentialite() {
  return (
    <div className="politique-container">
      <div className="politique-hero">
        <h1>🔒 Politique de Confidentialité</h1>
        <p>Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}</p>
      </div>

      <div className="politique-content">
        <section className="politique-section">
          <h2>1. Introduction</h2>
          <p>
            L'ASIFC (Association de Solidarité Internationale France-Comores) accorde une grande importance 
            à la protection de vos données personnelles. Cette politique de confidentialité vous informe sur 
            la manière dont nous collectons, utilisons et protégeons vos informations.
          </p>
        </section>

        <section className="politique-section">
          <h2>2. Données collectées</h2>
          <h3>2.1 Données que vous nous fournissez</h3>
          <ul>
            <li><strong>Formulaire de bénévolat :</strong> nom, prénom, email, téléphone, adresse postale</li>
            <li><strong>Réservation permanence numérique :</strong> nom, prénom, email, téléphone, motif de consultation</li>
            <li><strong>Contact :</strong> nom, email, message</li>
          </ul>

          <h3>2.2 Données collectées automatiquement</h3>
          <ul>
            <li><strong>Cookies techniques :</strong> nécessaires au fonctionnement du site</li>
            <li><strong>Cookies analytiques :</strong> statistiques de visite (si acceptés)</li>
            <li><strong>Données de navigation :</strong> pages visitées, durée, appareil utilisé</li>
          </ul>
        </section>

        <section className="politique-section">
          <h2>3. Utilisation des données</h2>
          <p>Vos données sont utilisées pour :</p>
          <ul>
            <li>Traiter vos demandes de bénévolat</li>
            <li>Gérer vos réservations pour les permanences numériques</li>
            <li>Vous contacter concernant nos activités et événements</li>
            <li>Améliorer notre site web et nos services</li>
            <li>Respecter nos obligations légales</li>
          </ul>
        </section>

        <section className="politique-section">
          <h2>4. Base légale du traitement</h2>
          <p>Nous traitons vos données sur la base de :</p>
          <ul>
            <li><strong>Votre consentement :</strong> pour les newsletters et communications marketing</li>
            <li><strong>L'exécution d'un contrat :</strong> pour traiter vos demandes de bénévolat ou réservations</li>
            <li><strong>Notre intérêt légitime :</strong> pour améliorer nos services</li>
            <li><strong>Obligations légales :</strong> pour la comptabilité et les déclarations obligatoires</li>
          </ul>
        </section>

        <section className="politique-section">
          <h2>5. Partage des données</h2>
          <p>
            Nous ne vendons jamais vos données personnelles. Nous pouvons les partager uniquement avec :
          </p>
          <ul>
            <li><strong>Nos partenaires :</strong> associations partenaires pour la réalisation de projets communs</li>
            <li><strong>Prestataires techniques :</strong> hébergement web, envoi d'emails (sous contrat de confidentialité)</li>
            <li><strong>Autorités :</strong> si requis par la loi</li>
          </ul>
        </section>

        <section className="politique-section">
          <h2>6. Durée de conservation</h2>
          <ul>
            <li><strong>Candidatures bénévoles :</strong> 3 ans après le dernier contact</li>
            <li><strong>Réservations permanences :</strong> 1 an après la date de permanence</li>
            <li><strong>Données comptables :</strong> 10 ans (obligation légale)</li>
            <li><strong>Cookies :</strong> 13 mois maximum</li>
          </ul>
        </section>

        <section className="politique-section">
          <h2>7. Vos droits</h2>
          <p>Conformément au RGPD, vous disposez des droits suivants :</p>
          <ul>
            <li><strong>Droit d'accès :</strong> obtenir une copie de vos données</li>
            <li><strong>Droit de rectification :</strong> corriger vos données inexactes</li>
            <li><strong>Droit à l'effacement :</strong> supprimer vos données (sous conditions)</li>
            <li><strong>Droit à la limitation :</strong> limiter le traitement de vos données</li>
            <li><strong>Droit d'opposition :</strong> vous opposer au traitement</li>
            <li><strong>Droit à la portabilité :</strong> récupérer vos données dans un format structuré</li>
            <li><strong>Droit de retirer votre consentement :</strong> à tout moment</li>
          </ul>
          <p>
            Pour exercer ces droits, contactez-nous à : <strong>asifc.rhone@gmail.com</strong>
          </p>
        </section>

        <section className="politique-section">
          <h2>8. Cookies</h2>
          <h3>8.1 Cookies nécessaires</h3>
          <p>
            Indispensables au fonctionnement du site (gestion de session, préférences de langue). 
            Ils ne peuvent pas être désactivés.
          </p>

          <h3>8.2 Cookies analytiques</h3>
          <p>
            Nous aident à comprendre comment vous utilisez notre site pour l'améliorer. 
            Vous pouvez les refuser via notre bannière de consentement.
          </p>

          <h3>8.3 Gestion des cookies</h3>
          <p>
            Vous pouvez modifier vos préférences à tout moment en supprimant les cookies de votre navigateur 
            ou en cliquant sur le lien "Gérer les cookies" en bas de page.
          </p>
        </section>

        <section className="politique-section">
          <h2>9. Sécurité</h2>
          <p>
            Nous mettons en œuvre des mesures de sécurité techniques et organisationnelles appropriées pour 
            protéger vos données contre :
          </p>
          <ul>
            <li>L'accès non autorisé</li>
            <li>La divulgation</li>
            <li>La modification</li>
            <li>La destruction</li>
          </ul>
          <p>
            Nos mesures incluent : chiffrement SSL, mots de passe sécurisés, accès restreint aux données, 
            sauvegardes régulières.
          </p>
        </section>

        <section className="politique-section">
          <h2>10. Transferts internationaux</h2>
          <p>
            Vos données sont hébergées en France/Europe. En cas de transfert hors UE, nous nous assurons 
            que des garanties appropriées sont en place (clauses contractuelles types, Privacy Shield).
          </p>
        </section>

        <section className="politique-section">
          <h2>11. Modifications</h2>
          <p>
            Nous pouvons modifier cette politique de confidentialité. Les modifications seront publiées 
            sur cette page avec une nouvelle date de mise à jour.
          </p>
        </section>

        <section className="politique-section">
          <h2>12. Contact</h2>
          <p>Pour toute question concernant cette politique de confidentialité :</p>
          <div className="contact-box">
            <p><strong>📧 Email :</strong> asifc.rhone@gmail.com</p>
            <p><strong>📍 Adresse :</strong> ASIFC, Rhône-Alpes, France</p>
            <p><strong>🛡️ DPO :</strong> Si vous estimez que vos droits ne sont pas respectés, vous pouvez introduire 
            une réclamation auprès de la CNIL (www.cnil.fr)</p>
          </div>
        </section>
      </div>
    </div>
  );
}

export default PolitiqueConfidentialite;